import React, { useState, useContext, useEffect } from "react";
import Application from "../../../StateContext/Application";

const PaymentTable = (props) => {
  const statecalls = useContext(Application);
  const { GetPaymentTable } = statecalls;
  const [paymenttable, setPaymentTable] = useState([]);
  const [paymentdata, setPaymentData] = useState({});

 

async function AllPaymentTable(e) {
    e.preventDefault()
    try {
      let data = await GetPaymentTable(paymentdata.para);
      setPaymentTable(data);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
        <div style={{backgroundColor:"#f6f8fc",padding:"50px"}}>
            <div style={{ display: "grid" ,border:"2px solid red",borderRadius:"20px",border:"none",padding:"20px",backgroundColor:'white'}}>
                <div style={{ display: 'grid' }}>
                    <div>
                        <label className='heading'>Search Payment Data</label>
                        <form onSubmit={AllPaymentTable} style={{width:'70vw'}} className='my-3'>
                            <input className='mb-3 form-control ' style={{ display: "flex", justifyContent: "center" }} type='search' id="para" placeholder='Enter Transaction ID/Pan Number/GST Number' onChange={(e)=>setPaymentData({...paymentdata,[e.currentTarget.id]:e.target.value})}/>
                            <button className="btn btn-primary" style={{backgroundColor:"#e73d26",border:"none"}}>Search</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
      <div style={{ padding: "50px",overflow:"auto"}}>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Scheme Name</th>
              <th>First Name</th>
              <th>Email</th>
              <th>Transaction ID</th>
              <th>Added Date</th>
              <th>Pan No</th>
              <th>GST No</th>
              <th>Status</th>
              <th>Payment Source</th>
              <th>Net Amount Debit</th>
              <th>Mode</th>
            </tr>
          </thead>
          <tbody>
            {
            paymenttable && paymenttable.map((e,index) => {
                return (
                  <tr key="index">
                    <td>{index+1}</td>
                    <td>{e.Tender_ID}</td>
                    <td>{e.firstname}</td>
                    <td>{e.email}</td>
                    <td>{e.easepayid}</td>
                    <td>{e.addedon}</td>
                    <td>{e.Organisation_ID}</td>
                    <td>{e.GST_No}</td>
                    <td>{e.status}</td>
                    <td>{e.payment_source}</td>
                    <td>{e.net_amount_debit}</td>
                    <td>{e.mode}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PaymentTable;
